import React from "react";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";

const PIE_PATHS = {
    0: null,
    1: "M0,0 L0,-1 A1,1 0 0,1 1,0 Z",
    2: "M0,0 L0,-1 A1,1 0 0,1 0,1 Z",
    3: "M0,0 L0,-1 A1,1 0 1,1 -1,0 Z",
    4: null,
};

const PieRenderer = ({ value, size }) => {
    const sizeToUse = size || 24;
    const r = sizeToUse / 2;
    const path = PIE_PATHS[value];
    const color = useSelector(getAppColor);

    return (
        <svg width={sizeToUse} height={sizeToUse} viewBox={`${-r} ${-r} ${sizeToUse} ${sizeToUse}`}>
            <circle cx={0} cy={0} r={r - 1} fill="transparent" stroke={color} strokeWidth={1} />
            {value === 4 ? (
                <circle cx={0} cy={0} r={r - 1} fill={color} />
            ) : path ? (
                <path d={path} fill={color} transform={`scale(${r - 1})`} />
            ) : null}
        </svg>
    );
};

export default PieRenderer;
